'use client';

import { useEffect } from 'react';
import {
  setInitialized,
  setQuizAnswers,
  setUserEvents,
  setUserNotes,
} from 'utils/useZStore';
import { useGetSupabaseUser } from '@/hooks/useGetSupabaseUser';
import { createBrowserClientSupa } from '../supabase/createBrowserClient';
import { getUserNotes } from '../get-user-notes';
import { trackSiteVisit } from '../track-visit';
import { getUserEvents } from '../get-user-events';
import { getQuizAnswers } from '../get-quiz-answers';

const useSignIn = () => {
  const supabase = createBrowserClientSupa();
  const user = useGetSupabaseUser();

  useEffect(() => {
    // TO-DO: Think if these queries can be optimised
    const getUserData = async () => {
      const userId = user?.id;
      // TO-DO: Handle errors
      const { data: userNotes } = await getUserNotes(userId);

      setUserNotes(userNotes);

      const { data: quizAnswers } = await getQuizAnswers(userId);
      const { data: userEvents } = await getUserEvents(userId);
      setQuizAnswers(quizAnswers);
      setUserEvents(userEvents);
      setInitialized(true);

      trackSiteVisit(userId);
    };

    if (user !== undefined) {
      getUserData();
    }
  }, [user, supabase]);
};

export default useSignIn;
